var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"roundup-alert",style:({ 'z-index': 205 })},[_c('v-snackbar',{ref:"snackbar",attrs:{"timeout":1000000,"value":_vm.showAlert,"color":_vm.alertColor}},[(_vm.icon)?_c('v-icon',{attrs:{"size":"20"}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]):_vm._e(),_c('span',{style:({
				'margin-left': _vm.icon ? '5px' : ''
			}),attrs:{"id":"text"}},[_vm._v(" "+_vm._s(_vm.alertText)+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }